export const checksums = {
  "faq": "v3.5.0--wkUhzQoUw9o7JxFWPVb8z2kEKQxBIcTS7CRz-6lX2Hw",
  "articles": "v3.5.0--l7Crtx4yuVgnCM1PFHabrQaS61WgE8BsEwEuTy6X55E"
}
export const checksumsStructure = {
  "faq": "O3YlnC2pJjny2VxFV2NTWzmdJ-4EmBdiVul-x_C6jK8",
  "articles": "M3w2bOMTT9qO1bEsGkZgXq5XBt0UXknKDcciPMJgd9A"
}

export const tables = {
  "faq": "_content_faq",
  "articles": "_content_articles",
  "info": "_content_info"
}

export default {
  "faq": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "extension": "string",
      "items": "json",
      "meta": "json",
      "stem": "string"
    }
  },
  "articles": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "author": "string",
      "body": "json",
      "date": "string",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "slug": "string",
      "stem": "string",
      "thumbnail": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}